import { hot } from "react-hot-loader";
import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Provider } from "react-redux";
import store from "./config/store";
import { history } from "./reducer";

import "./styles/common.scss";

import { AppRouter } from "./config/router/AppRouter";

class App extends React.Component {
  render() {
    return (
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <AppRouter />
        </ConnectedRouter>
      </Provider>
    );
  }
}

export default hot(module)(App);
